import React, { Component } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';
import './Onboarding.module.scss';
import { connect } from 'react-redux';

import updateUser from 'actions/user/update';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const mapDispatchToProps = {
    updateUser
};

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user
    };
};

const steps = [
    {
        image: 'images/onboarding/Walkthrough-1en2.png',
        text: 'WELKOM BIJ DE PLENDA APPLICATIE!'
    },
    {
        video: 'https://www.youtube.com/embed/z-kC-LlsB4Q',
        text: 'Bekijk eerst de Plenda Applicatie in vogelvlucht en ga daarna direct aan de slag! '
    },
    {		
        image: 'images/onboarding/aan-de-slagv2.gif',		
        text: 'Succes met plannen!'		
    }
];

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentStep: 0
        };

        this.goToStep = this.goToStep.bind(this);
        this.goLeft = this.goLeft.bind(this);
        this.goRight = this.goRight.bind(this);
        this.finishOnboarding = this.finishOnboarding.bind(this);
        
    }

    componentDidMount() {

    }

    goToStep(step) {
        this.setState({ currentStep: step });
    }

    goLeft() {
        if (this.state.currentStep > 0) {
            this.setState({ currentStep: this.state.currentStep - 1 });
        }
    }

    goRight() {
        this.setState({ currentStep: this.state.currentStep + 1 });
    }

    finishOnboarding() {
        this.props.updateUser({
            ...this.props.user,
            finished_onboarding: true
        }).then(() => history.push('/agenda'));
    }

    render() {
        return (
            <div styleName="login-background">
                <div styleName="top-bar">
                    <img onClick={() => {history.push('/')}} styleName="logo" src='images/logos/plenda-logo.svg' />
                </div>
                <div styleName="content">
                    <div styleName="image-wrapper">
                        {this.state.currentStep > 0 && <div onClick={this.goLeft} styleName='arrow-left'><FontAwesomeIcon icon={[ 'far', 'angle-left' ]} /></div> }
                        {
                            steps[this.state.currentStep].image &&
                        
                               <img styleName="image" src={steps[this.state.currentStep].image} />
                        }
                        {
                            steps[this.state.currentStep].video &&
                        
                            <iframe width="560" height="315" src={steps[this.state.currentStep].video} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        }
                        {this.state.currentStep < (steps.length - 1) && <div onClick={this.goRight} styleName='arrow-right'><FontAwesomeIcon icon={[ 'far', 'angle-right' ]} /></div> }
                    </div>
                    <p>
                        {steps[this.state.currentStep].text}
                        {this.state.currentStep == (steps.length - 1) && 
                            <span onClick={this.finishOnboarding}>Ga naar de app</span>
                        } 
                    </p>
                    
                    <div styleName='navigation'>
                        {steps.map((step, index) => (
                            <Dot index={index} active={index == this.state.currentStep} handleClick={this.goToStep} />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

class Dot extends Component {

    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.handleClick(this.props.index);
    }

    render() {
        return (
            <div onClick={this.handleClick} styleName={`dot ${this.props.active ? 'active' : ''}`}></div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);